export default {
    token: null,
    loading: false,
    error: null,
    hspcAuthorized : false,
    fhirClient: null,
    fhirVersion: null,
    scope: 'smart/orchestrate_launch user/*.* profile openid',
}



// WEBPACK FOOTER //
// ./src/redux/reducers/fhirauth/init.js